export const projects = [
    {
        id: 1,
        title: "CS-Butler - JavaScript Slackbot for Streamlined Support",
        description: "Developed a Slack app for automated support, improving team coordination and workflow efficiency using JavaScript, Slack API, JIRA API, and Opsgenie API.",
        techStack: ["JavaScript", "Slack API", "JIRA API", "Opsgenie API"],
        imageUrl: "/images/csbutler.jpg", // Replace with your actual image path
        liveDemoUrl: "#", // Replace with your actual URL, if available
        githubUrl: "#" // Replace with your actual URL, if available
    },
    
    // Add more projects here
];
